export const translateModules = t => ({
  MENU_PLANNER: t('common.mainMenu.menuPlanner'),
  MENU_PLANNER_AUTO_FILL: t('rolesForm.autoFill'),
  MENU: t('common.mainMenu.menuPlanner'),
  SIZE: t('common.mainMenu.sizes'),
  BAG_CONTAINER: t('common.mainMenu.bagContainer'),
  CONTRACTOR: t('rolesForm.contractors'),
  MEAL_TYPE: t('common.mainMenu.typesOfMeals'),
  DISH_CATEGORY: t('common.mainMenu.dishCategories'),
  DIET: t('$*common.diets'),
  INGREDIENT: t('common.mainMenu.ingredients'),
  RECIPE: t('common.mainMenu.recipes'),
  DISH: t('common.mainMenu.meals'),
  PACKAGE: t('common.mainMenu.packages'),
  PACKAGE_LINE_FILTER: t('common.mainMenu.dietLine'),
  VARIANT: t('common.mainMenu.variants'),
  DICTIONARY: t('common.mainMenu.dictionariesCaption'),
  PICK_UP_POINT: t('common.mainMenu.pickupPoints'),
  COMPANY: t('rolesForm.company'),
  USER: t('common.mainMenu.clients'),
  // EMPLOYEE: t('common.mainMenu.myCompanyEmployees', 'Pracownicy'),
  IMPERSONATE_USER: t('rolesForm.impersonating'),
  BRAND: t('common.mainMenu.myCompanyBrands'),
  SHOW_MENU_PAGE: t('rolesForm.menuPage'),
  ROLE: t('common.mainMenu.myCompanyRoles'),
  ZONE_CATEGORY: t('common.mainMenu.zoneCategories'),
  ZONE: t('common.mainMenu.zones'),
  BAG: t('ecommerceBags.name'),
  BASKET: t('basket.menu'),
  COST: t('common.mainMenu.priceLists'),
  ADDRESS: t('clients.addresses'),
  DISCOUNT_CODE: t('common.mainMenu.discountCodes'),
  DRIVER: t('common.mainMenu.drivers'),
  MONEY_BOX_HISTORY: t('clients.moneybox'),
  ORDER: t('clients.orders'),
  NOTE: t('rolesForm.clientNotes'),
  SMS: t('rolesForm.clientSMS'),
  EMAIL: t('rolesForm.clientEmail'),
  RATE: t('rolesForm.rates'),
  SUB_BRAND: t('common.mainMenu.subBrands'),
  SUB: t('common.mainMenu.subBrands'),
  OVERPRODUCTION: t('list.additionalOrders'),
  HOVER: t('common.mainMenu.hover'),
  WASTE: t('common.mainMenu.waste'),
  MONEY_BOX_CONFIGURATION: t('common.mainMenu.moneyBoxConfig'),
  MAIL_CONFIGURATION: t('common.mainMenu.myCompanyMailNotifications'),
  SMS_CONFIGURATION: t('common.mainMenu.myCompanySmsNotifications'),
  END_OF_DIET_REMINDER: t('rolesForm.endOfDietReminder'),
  END_OF_DIET_REMINDER_MAIL: t('common.mainMenu.myCompanyMailReminders'),
  END_OF_DIET_REMINDER_SMS: t('common.mainMenu.myCompanySmsReminders'),
  COMMUNICATION_RULE: t('common.mainMenu.communicationRules'),
  NOTIFICATION: t('common.mainMenu.messages'),
  // REPORT_EMPLOYEE: t('rolesForm.employeeReport', 'Raport - Pracownicy'),
  REPORT_DISH_LIST: t('rolesForm.dishListReport'),
  REPORT_DISH_STICKERS: t('rolesForm.stickersReport'),
  /*   REPORT_EMPLOYEE_TIME_ENTRIES: t(
    'common.mainMenu.employeesReport'
  ), */
  REPORT_BAG_STICKERS: t('rolesForm.labelsReport'),
  REPORT_BAG_STICKERS_MINI: t('rolesForm.labelsReportMini'),
  REPORT_DISHES_CARD: t('rolesForm.menuCardsReport'),

  REPORT_RECIPES_CARD: t('rolesForm.recipeCardsReport'),
  REPORT_RECIPES_INGREDIENTS: t('rolesForm.recipeIngredientsReport'),
  // REPORT_SENT_SMS: t('reports.reportSentSms'),
  REPORT_ACCOUNTANT_INCOME: `${t('reports.accountant')} - ${t(
    'reports.accountant.income'
  )}`,
  REPORT_ACCOUNTANT_NEW_ACCOUNTS: `${t(
    'reports.accountant',
    'Raporty księgowe'
  )} - ${t('reports.accountant.newAccounts')}`,
  REPORT_ACCOUNTANT_DEPOSIT_AND_REFUNDS: `${t('reports.accountant')} - ${t(
    'reports.accountant.depositAndRefunds'
  )}`,
  REPORT_FOR_DRIVER: t('rolesForm.forDriverReport'),
  REPORT_SHOPPING: t('rolesForm.shopListReport'),
  REPORT_CONTAINERS: t('rolesForm.containersReport'),
  REPORT_CONTAINERS_DETAIL: t('rolesForm.containersDetReport'),
  REPORT_USAGE_DISCOUNT_CODES: t('rolesForm.usedDiscCodesReport'),
  REPORT_MONEY_BOX_TOP_UP: t('rolesForm.topUpReport'),
  ADDITIONAL_OFFER: t('common.mainMenu.navLinks.additionalOffer'),
  REPORT_OVERPRODUCTION: t('rolesForm.addOrdersReport'),
  REPORT_OVERPRODUCTION_FOOD_COST: t('rolesForm.addOrdersFoodCostReport'),
  REPORT_WASTE: t('rolesForm.lossesReport'),
  REPORT_CHECKLIST_RECIPES: t('rolesForm.recipesChecklistReport'),
  REPORT_CHECKLIST_DISHES: t('rolesForm.foodChecklistReport'),
  REPORT_ACTIVE_DIET: t('common.mainMenu.reportActiveDiets'),
  REPORT_ORDERED_DIET: t('common.mainMenu.reportOrderedDiets'),
  REPORT_PERSONAL_PICKUPS: t('common.mainMenu.reportPersonalPickups'),
  REPORT_PACKERS: t('common.mainMenu.reportPackers'),
  REPORT_RECIPE_STICKERS: t('common.mainMenu.reportRecipeStickers'),
  REPORT_INCOME_SUMMARY: t('common.mainMenu.reportsIncomeSummary'),
  REPORT_FOOD_COST: t('rolesForm.raportFoodCost'),
  REPORT_FOOD_COST_BAGS: t('rolesForm.raportFoodCostBags'),
  REPORT_INCOMING_SUBSCRIPTION: t('rolesForm.incomingSubscriptionsReport'),
  REPORT_PURCHASED_ADDONS: t('rolesForm.raportAddonList'),
  REPORT_PURCHASED_ADDONS_BY_CLIENT:
    t('rolesForm.reportPrefix') +
    t('common.mainMenu.reportsAddonsByClientList'),
  REPORT_ARCHIVE: t('reportArchive'),
  PAGE: t('rolesForm.subpages'),
  MASS_SMS: t('rolesForm.massSMS'),
  MASS_MAIL: t('rolesForm.massMail'),
  MASS_ACTION: t('massAction.dietElements.title'),
  IMPORTER_TASK: t('rolesForm.importer'),
  STATISTICS: t('rolesForm.statistics'),
  MAILING: t('rolesForm.mailing'),
  SMSING: t('rolesForm.smsing'),
  MODULE_ADDONS: t('rolesForm.addonsModuleSettings'),
  MODULE_SHOP: t('common.mainMenu.shop'),
  REPORT_ADVANCED_DISH_PDF: t('rolesForm.advancedPdfRaport'),
  MODULE_DISH_PDF_GENERATOR: t('rolesForm.advancedDishConfigurationModule'),
  MODULE_MENU_SELECTION_ASSISTANT: t('rolesForm.menuSelectionAssistantModule'),
  ADDON: t('rolesForm.addon'),
  BRAND_ACCESS_KEY: t('brandCfg.accessKeysLabel'),
  FEED: t('brandCfg.productFeedLabel'),
  /*   ROUTE_POINT: t('routePlanner.menuTitle'),
  ROUTE_MANAGER: t('routeManager.menuTitle'), */
  MODULE_SETTLEMENTS: t('moduleSettlements'),
  ADDRESS_REQUESTS: t('rolesForm.addressRequests'),
  REPORT_CHECKLIST_DIETS: t('rolesForm.dietsChecklistReport'),
  MENU_SUMMARY: t('rolesForm.menuSummary'),
  REPORT_CHECKLIST_ALTERED_DIETS: t('rolesForm.alteredDietsChecklistReport'),
  TRANSLATION: t('common.mainMenu.translations'),
  REPORT_MACRO_INGREDIENTS: t('common.mainMenu.macroIngredientsReport'),
  USE_MINI_ADDRESS_FORM: t('common.rolesForm.useLessFieldsForm'),
  REPORT_TOTAL_BEL: t('rolesForm.totalBelReport'),
  TASKS_GENERATOR: t('common.mainMenu.tasksGenerator'),
  KITCHEN: t('common.mainMenu.kitchen'),
  DISH_PACKHOUSE: t('common.mainMenu.dishesPackhouse'),
  BAGS_PACKHOUSE: t('common.mainMenu.bagsPackhouse'),
  CMS_DIET: t('common.mainMenu.CMS.diets'),
  CMS_DISH: t('common.mainMenu.CMS.dishes'),
  CMS_ADDON: t('common.mainMenu.CMS.addons'),
  CMS_MENU: t('common.mainMenu.CMS.menu'),
  HOME_PAGE: t('common.mainMenu.CMS.homePage'),
  CMS_ZONE: t('common.mainMenu.CMS.zone'),
  BLOG_POST: t('common.mainMenu.CMS.blog'),
  PRODUCT: t('common.mainMenu.products'),
  SEO: t('common.rolesForm.seo'),
  CMS_SUBPAGE: t('common.mainMenu.CMS.subPage'),
  MODULE_GOOGLE_ANALYTICS: t('common.rolesForm.integrations.googleAnalytics'),
  MODULE_GOOGLE_TAG_MANAGER: t(
    'common.rolesForm.integrations.googleTagMenager'
  ),
  MODULE_FACEBOOK_PIXEL: t('common.rolesForm.integrations.facebookPixel'),
  MODULE_SALES_MANAGO: t('common.rolesForm.integrations.salesManago'),
  MODULE_GET_RESPONSE: t('common.rolesForm.integrations.getResponse'),
  MODULE_USER_COM: t('common.rolesForm.integrations.usercom'),
  MODULE_CLICK_ON_METRICS: t('common.rolesForm.integrations.clickOnMetrics'),
  MODULE_POLLSTER_TRACK: t('common.rolesForm.integrations.pollsterTrack'),
  MODULE_BITRIX_24: t('common.rolesForm.integrations.bitrix'),
  MODULE_TRUSTED_SHOPS: t('common.rolesForm.integrations.trustedShops'),
  MODULE_THULIUM: t('common.rolesForm.integrations.thulium'),
  MODULE_OMNICONVERT: t('common.rolesForm.integrations.omniconvert'),
  MODULE_SCAN_AND_SORT: t('common.rolesForm.integrations.scanAndSort'),
  STATISTICS_ECOMMERCE_CALCULATION_DATA: t(
    'common.rolesForm.settlements.statistics'
  ),
  DISH_PHOTO_GALLERY: t('common.rolesForm.dishesPhotoGallery'),
  INGREDIENT_PRICE: t('common.rolesForm.ingredient.price'),
  INGREDIENT_TRANSLATIONS: t('common.rolesForm.ingredient.translations'),
  DISH_TRANSLATIONS: t('common.rolesForm.dishes.translations'),
  CLIENT_METRIC: t('common.rolesForm.clientMetric'),
  ROLE_SHOW_REPORT_DISPOSAL: t('common.rolesForm.disposal'),
  ROLE_SHOW_REPORT_SELECTIONS: t('common.roles.role.showReportSelections'),
  COPY_BRAND_CONFIGURATION: t('common.rolesForm.copyBrandConfiguration'),
  KWG_GROUP: t('common.rolesForm.kwgGroup'),
});
